export default "__VITE_ASSET__nkb6G76W__"